import React from "react";
import { Plus } from "lucide-react";

import ButtonV2 from "../../../components/ui/button/v2";

export interface AddLoanAccountButtonProps {
  disabled?: boolean;
  onClick: () => void;
}

const AddLoanAccountButton: React.FC<AddLoanAccountButtonProps> = ({ disabled, onClick }) => (
  <ButtonV2 variant="ghost" size="sm" disabled={disabled} onClick={onClick}
    className="text-[#3551F3] bg-transparent self-start disabled:opacity-40"
    prefix={<Plus width="16" height="16" />}>
    Add Loan Account
  </ButtonV2>
);

export default AddLoanAccountButton;
